import type { DocMigration } from "../docMigration";
import { forEachFormula } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_173: DocMigration = {
  maxSchemaVersion: "0.0.173",
  description:
    "Removes the 'type', 'mgmtType', 'defaultValue', and 'values' properties of Param, removing the BOOLEAN type as a result. Converts all 'design' values to strings. Converts all true/false values in formulas to their string equivalents.",
  apply(json: any) {
    const truePattern = /=\s?true/g;
    const falsePattern = /=\s?false/g;

    for (const paramId in json.params) {
      const param = json.params[paramId];

      // All params should have "config.valueConfig" defined now
      if (typeof param.config !== "object" || param.config === null) {
        param.config = { valueConfig: {} };
      } else if (typeof param.config?.valueConfig !== "object" || param.config?.valueConfig === null) {
        param.config.valueConfig = {};
      }

      // The "disconnectConditions" formula strings need to treat "true" and "false" as strings now
      if (typeof param.config.disconnectConditions === "string") {
        param.config.disconnectConditions = param.config.disconnectConditions.replace(truePattern, '= "true"');
        param.config.disconnectConditions = param.config.disconnectConditions.replace(falsePattern, '= "false"');
      }

      if (param?.type === "BOOLEAN") {
        // Ensure "BOOLEAN" params have minimal "true" and "false" entries in their "valueConfig"
        param.config.valueConfig.true = param.config.valueConfig.true ?? {};
        param.config.valueConfig.false = param.config.valueConfig.false ?? {};
      } else {
        // For STRING_ENUM params, make sure entries of "values" array are represented with a minimal "valueConfig" entry
        if (param?.values) {
          for (const value in param.values) {
            const valueId = param.values[value];

            if (typeof param.config.valueConfig[valueId] !== "object" || param.config.valueConfig[valueId] === null) {
              param.config.valueConfig[valueId] = {};
            }
          }
        }
      }

      // Remove "values" property
      delete param.values;

      // Remove "type" property
      delete param.type;

      // Param 'defaultValue' remvoed in favor of Param 'config.defaultValue"; latter has priority
      if (typeof param.config.defaultValue === "undefined" || param.config.defaultValue === null) {
        if (typeof param.defaultValue === "undefined" || param.defaultValue === null) {
          // Use first value in 'valueConfig' object as default
          param.config.defaultValue = Object.keys(param.config.valueConfig)[0];
        } else {
          param.config.defaultValue = param.defaultValue;
        }
      }

      // Ensure 'defaultValue' is a string
      if (typeof param.config.defaultValue !== "undefined" && param.config.defaultValue !== null) {
        param.config.defaultValue = String(param.config.defaultValue);
      }

      // Remove param.defaultValue
      delete param.defaultValue;

      // Remove param.config.mgmtType
      if (param.config) {
        delete param.config.mgmtType;
      }
    }

    // Convert true/false to string equivalents in all formulas on the document
    forEachFormula(json, (formulaObj) => {
      formulaObj.formula = formulaObj.formula.replace(truePattern, '= "true"');
      formulaObj.formula = formulaObj.formula.replace(falsePattern, '= "false"');
    });

    // All design values should be strings
    for (const paramId in json.design) {
      json.design[paramId] = String(json.design[paramId]);
    }

    return json;
  },
};

export default migration_0_0_173;
